import { render, staticRenderFns } from "./expo-program-item.vue?vue&type=template&id=b696de70"
import script from "./expo-program-item.vue?vue&type=script&lang=js"
export * from "./expo-program-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports